const search = {
  state: {
    isSearchSubmit: 0,
    isHideSearch: true,
    formData: {},
    formItems: [],
    dataPickerRangeDay: 0
  },
  getters: {
    formSearch: state => { //通过方法访问
      return state.formData
    },
  },
  mutations: {

    // 配置search栏目初始化
    setSearchFormConfig(state, searchFormConfig) {
      if (!searchFormConfig) {
        state.isHideSearch = true
        state.formData = {}
        state.formItems = []
        state.formRules = {}
        return
      }
      searchFormConfig.importModal == "component" ? state.isHideSearch = true : state.isHideSearch = false
      var data = {};
      if (searchFormConfig.formItems instanceof Array) {
        searchFormConfig.formItems.forEach(element => {
          if (element.value) {
            data[element.keyName] = element.value
          } else {
            data[element.keyName] = ""
          }
          if (element._type == "dataPickerRange") {
            state.dataPickerRangeDay = element.rangeDay
          }
        });
      }
      state.formData = data
      state.formItems = searchFormConfig.formItems
    },
    clearSearchFormData(state) {
      //以防单重置值不生效
      var params = JSON.parse(JSON.stringify(state.formData))
      for (let key in params) {
        if (key != "dateVal") {
          params[key] = ""
        }else{
          params[key] =window.publicMethods.setCurrentTimeFormat(-7, 7)
        }
      }
      state.formData = params
    },
    //监听查询按钮是否点击
    setIsSearchSubmit(state) {
      state.isSearchSubmit++
    }
  },

  actions: {

  }

}

export default search
